const img = require('./TripleDoor.svg'); export default img;